import { Flex } from '@chakra-ui/react';
import { Modal } from '@kula-ai/components';
import { PDFReaderBrowser } from '@/components/file-viewers/reactPdf';
import { useIsMobile } from '@/hooks/use-IsMobile';

type PreviewFile =
  | File
  | {
      url?: string;
      file_name?: string;
      filename?: string;
      name?: string;
      content_type?: string;
      type?: string;
      preview?: { url?: string } | null;
    };

interface PreviewPdfModalProps {
  isOpen?: boolean;
  onClose?: () => void;
  file?: PreviewFile;
}

const getDisplayName = (file?: PreviewFile): string | undefined => {
  if (!file) return undefined;
  if (file instanceof File) return file.name;
  return file.file_name || file.filename || file.name;
};

const getFileUrl = (file?: PreviewFile): string => {
  if (!file) return '';
  if (file instanceof File) return URL.createObjectURL(file);
  return file.url ?? '';
};

const getContentType = (file?: PreviewFile): string => {
  if (!file) return '';
  if (file instanceof File) return file.type;
  return file.content_type || file.type || '';
};

const getPreviewUrl = (file?: PreviewFile): string => {
  if (!file || file instanceof File) return '';
  return file.preview?.url ?? '';
};

export const PreviewPdfModal = ({
  isOpen = false,
  onClose = () => {},
  file,
}: PreviewPdfModalProps) => {
  const isMobile = useIsMobile();
  const displayName = getDisplayName(file);
  return (
    <Modal
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
      title={displayName}
      size={isMobile ? 'full' : 'xl'}
      preventClose={false}
      primaryButton={{ hidden: true }}
      secondaryButton={{ hidden: true }}
    >
      <Flex w="100%" h="70vh" overflow="auto" flexDir="column">
        <PDFReaderBrowser
          file={getFileUrl(file)}
          content_type={getContentType(file)}
          preview_url={getPreviewUrl(file)}
          fileName={displayName}
        />
      </Flex>
    </Modal>
  );
};
